export default __webpack_public_path__ + "static/media/AneomiBg.7033b498.jpg";